import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

import { translate } from 'react-i18next';
import { ReduxAsyncConnect, asyncConnect, reducer as reduxAsyncConnect } from 'redux-connect';

import { reduxForm, initialize } from 'redux-form';
import { initializeWithKey } from 'redux-form';

import { isLoaded, load as loadFiches } from 'redux/modules/fiches';
import * as FicheActions from 'redux/modules/fiches';

import { FicheForm } from 'components';

import { isLoaded as areGroupsLoaded, load as loadGroups } from 'redux/modules/groups';

require('./geosuggest.css');

@asyncConnect([{
  promise: ({ store: { dispatch, getState }, params }) => {
    const promises = [];
    //if ( !areGroupsLoaded(getState()) ) {
    promises.push(dispatch(loadGroups(params)));
    //}
    return Promise.all(promises);
  }
}])
@connect(
  state => ({
    groups: state.groups.data,
  })
)
@translate(['common'])

export default class AddFiche extends Component {

  render() {
    const {
      t, groups
    } = this.props;

    const styles = require('./AddFiche.scss');

    return (
      <div className={'container'}>
        <Helmet title={t('addFiche.create_product_sheet')} />
        <h1>
          {t('addFiche.create_site')}
        </h1>

        <FicheForm action='create' urlParams={this.props.params} formKey="createFicheForm1" />
      </div>
    );
  }
}
